import React from 'react';
import { Button, Input, ModalHeader, ModalBody } from 'reactstrap';
import AssessmentCard from './AssessmentCard';
import styles from './RubricQuestionPickerModal.module.scss';

export default function PickAssessmentPhase({
  assessmentGroups,
  filtered,
  searching,
  canCollapseLowTier,
  topTier,
  lowTier,
  showLowTierList,
  searchQuery,
  onSearchChange,
  onChooseAssessment,
  onShowAllBelowCutoff,
  onClose = () => {},
}) {
  return (
    <>
      <ModalHeader tag="div" toggle={onClose}>
        <h5 className="modal-title">Choose an assessment</h5>
        <div>
          <div className={styles['picker-assessment-search']}>
            <Input
              type="search"
              bsSize="sm"
              className={styles['picker-assessment-search-input']}
              placeholder="Search by name or key…"
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              aria-label="Filter assessments"
            />
          </div>
        </div>
      </ModalHeader>
      <ModalBody>
        <div className={styles['picker-phase-pick']}>
          {filtered.length === 0 && (
            <p className="text-muted mb-0">
              {assessmentGroups.length === 0
                ? 'No questions available.'
                : 'No matching assessments.'}
            </p>
          )}

          {searching &&
            filtered.map((group) => (
              <AssessmentCard
                key={group.key}
                group={group}
                onChooseAssessment={onChooseAssessment}
              />
            ))}
          {!searching &&
            !canCollapseLowTier &&
            filtered.map((group) => (
              <AssessmentCard
                key={group.key}
                group={group}
                onChooseAssessment={onChooseAssessment}
              />
            ))}

          {!searching && canCollapseLowTier && (
            <>
              <div className={styles['picker-assessment-section-title']}>
                Most used
              </div>
              {topTier.map((group) => (
                <AssessmentCard
                  key={group.key}
                  group={group}
                  onChooseAssessment={onChooseAssessment}
                />
              ))}

              {!showLowTierList && (
                <div className={styles['picker-show-all-wrap']}>
                  <Button
                    type="button"
                    color="link"
                    className={styles['picker-show-all-btn']}
                    onClick={onShowAllBelowCutoff}
                  >
                    Show all ({lowTier.length} more)
                  </Button>
                </div>
              )}

              {showLowTierList && lowTier.length > 0 && (
                <>
                  <div
                    className={`${styles['picker-assessment-section-title']} ${styles['picker-assessment-section-title-follow']}`}
                  >
                    Other assessments
                  </div>
                  {lowTier.map((group) => (
                    <AssessmentCard
                      key={group.key}
                      group={group}
                      onChooseAssessment={onChooseAssessment}
                    />
                  ))}
                </>
              )}
            </>
          )}
        </div>
      </ModalBody>
    </>
  );
}
